import { PROVIDER_DETAILS_FORM_FIELDS, PROVIDER_DETAILS_FORM_FIELDS_NAMES } from './provider-details-form';
import { getFormattedNumberValue, VALUE_TYPE } from '../../components/general-components/NumberFormatterComponent';
import { InputType } from '../../components/form/form-input-constants';

interface IFakeInputProps {
  initialNumber: number;
  type: VALUE_TYPE;
  shorterNumberFormat?: boolean;
  currency?: string;
}
const showFakeInputValue = ({ initialNumber, type, shorterNumberFormat, currency }: IFakeInputProps): string => {
  return `${initialNumber && currency ? currency : ''}${getFormattedNumberValue({ initialNumber, type, shorterNumberFormat })}`;
};
export const TOTAL_INPUTS = (formik): any[] => [
  {
    key: PROVIDER_DETAILS_FORM_FIELDS.TOTAL_MONTHLY_MAX_TRANSACTIONS_COUNT,
    fieldName: PROVIDER_DETAILS_FORM_FIELDS.TOTAL_MONTHLY_MAX_TRANSACTIONS_COUNT,
    label: PROVIDER_DETAILS_FORM_FIELDS_NAMES.TOTAL_MONTHLY_MAX_TRANSACTIONS_COUNT,
    placeholder: PROVIDER_DETAILS_FORM_FIELDS_NAMES.TOTAL_MONTHLY_MAX_TRANSACTIONS_COUNT,
    tooltipText: PROVIDER_DETAILS_FORM_FIELDS_NAMES.TOTAL_TOOLTIP_TEXT,
    isEditable: true,
    isUnlimited: true,
    inputType: InputType.Number,
    metricValue: formik.values[PROVIDER_DETAILS_FORM_FIELDS.TOTAL_TRANSACTION_COUNT],
    metricType: 'count',
    formattedValue: () => showFakeInputValue({ initialNumber: formik.values[PROVIDER_DETAILS_FORM_FIELDS.TOTAL_MONTHLY_MAX_TRANSACTIONS_COUNT], type: VALUE_TYPE.COUNT, shorterNumberFormat: true }),
    formattedTooltipValue: () => showFakeInputValue({ initialNumber: formik.values[PROVIDER_DETAILS_FORM_FIELDS.TOTAL_MONTHLY_MAX_TRANSACTIONS_COUNT], type: VALUE_TYPE.COUNT, shorterNumberFormat: false }),
    showValueInTooltip: Number(formik.values[PROVIDER_DETAILS_FORM_FIELDS.TOTAL_MONTHLY_MAX_TRANSACTIONS_COUNT]) > 999,
    orientation: 'horizontal',
  },
  {
    key: PROVIDER_DETAILS_FORM_FIELDS.TOTAL_MONTHLY_MAX_TRANSACTIONS_VALUE,
    fieldName: PROVIDER_DETAILS_FORM_FIELDS.TOTAL_MONTHLY_MAX_TRANSACTIONS_VALUE,
    label: PROVIDER_DETAILS_FORM_FIELDS_NAMES.TOTAL_MONTHLY_MAX_TRANSACTIONS_VALUE,
    placeholder: PROVIDER_DETAILS_FORM_FIELDS_NAMES.TOTAL_MONTHLY_MAX_TRANSACTIONS_VALUE,
    tooltipText: PROVIDER_DETAILS_FORM_FIELDS_NAMES.TOTAL_TOOLTIP_TEXT,
    isEditable: true,
    isUnlimited: true,
    inputType: InputType.Number,
    metricValue: formik.values?.[PROVIDER_DETAILS_FORM_FIELDS.TOTAL_TRANSACTION_VALUE],
    metricType: 'amount',
    metricCurrency: '$',
    formattedValue: () => showFakeInputValue({ initialNumber: formik.values[PROVIDER_DETAILS_FORM_FIELDS.TOTAL_MONTHLY_MAX_TRANSACTIONS_VALUE], type: VALUE_TYPE.AMOUNT, shorterNumberFormat: true, currency: '$' }),
    formattedTooltipValue: () => showFakeInputValue({ initialNumber: formik.values[PROVIDER_DETAILS_FORM_FIELDS.TOTAL_MONTHLY_MAX_TRANSACTIONS_VALUE], type: VALUE_TYPE.AMOUNT, shorterNumberFormat: false, currency: '$' }),
    showValueInTooltip: Number(formik.values[PROVIDER_DETAILS_FORM_FIELDS.TOTAL_MONTHLY_MAX_TRANSACTIONS_VALUE]) > 999,
    orientation: 'horizontal',
  },

  {
    key: PROVIDER_DETAILS_FORM_FIELDS.TOTAL_DAILY_MAX_TRANSACTIONS_COUNT,
    fieldName: PROVIDER_DETAILS_FORM_FIELDS.TOTAL_DAILY_MAX_TRANSACTIONS_COUNT,
    label: PROVIDER_DETAILS_FORM_FIELDS_NAMES.TOTAL_DAILY_MAX_TRANSACTIONS_COUNT,
    placeholder: PROVIDER_DETAILS_FORM_FIELDS_NAMES.TOTAL_DAILY_MAX_TRANSACTIONS_COUNT,
    tooltipText: PROVIDER_DETAILS_FORM_FIELDS_NAMES.TOTAL_TOOLTIP_TEXT,
    isEditable: true,
    isUnlimited: true,
    inputType: InputType.Number,
    metricValue: formik.values[PROVIDER_DETAILS_FORM_FIELDS.TOTAL_DAILY_TRANSACTION_COUNT],
    metricType: 'count',
    formattedValue: () => showFakeInputValue({ initialNumber: formik.values[PROVIDER_DETAILS_FORM_FIELDS.TOTAL_DAILY_MAX_TRANSACTIONS_COUNT], type: VALUE_TYPE.COUNT, shorterNumberFormat: true }),
    formattedTooltipValue: () => showFakeInputValue({ initialNumber: formik.values[PROVIDER_DETAILS_FORM_FIELDS.TOTAL_DAILY_MAX_TRANSACTIONS_COUNT], type: VALUE_TYPE.COUNT, shorterNumberFormat: false }),
    showValueInTooltip: Number(formik.values[PROVIDER_DETAILS_FORM_FIELDS.TOTAL_DAILY_MAX_TRANSACTIONS_COUNT]) > 999,
    orientation: 'horizontal',
  },
  {
    key: PROVIDER_DETAILS_FORM_FIELDS.TOTAL_DAILY_MAX_TRANSACTIONS_VALUE,
    fieldName: PROVIDER_DETAILS_FORM_FIELDS.TOTAL_DAILY_MAX_TRANSACTIONS_VALUE,
    label: PROVIDER_DETAILS_FORM_FIELDS_NAMES.TOTAL_DAILY_MAX_TRANSACTIONS_VALUE,
    placeholder: PROVIDER_DETAILS_FORM_FIELDS_NAMES.TOTAL_DAILY_MAX_TRANSACTIONS_VALUE,
    tooltipText: PROVIDER_DETAILS_FORM_FIELDS_NAMES.TOTAL_TOOLTIP_TEXT,
    isEditable: true,
    isUnlimited: true,
    inputType: InputType.Number,
    metricValue: formik.values?.[PROVIDER_DETAILS_FORM_FIELDS.TOTAL_DAILY_TRANSACTION_VALUE],
    metricType: 'amount',
    metricCurrency: '$',
    formattedValue: () => showFakeInputValue({ initialNumber: formik.values[PROVIDER_DETAILS_FORM_FIELDS.TOTAL_DAILY_MAX_TRANSACTIONS_VALUE], type: VALUE_TYPE.AMOUNT, shorterNumberFormat: true, currency: '$' }),
    formattedTooltipValue: () => showFakeInputValue({ initialNumber: formik.values[PROVIDER_DETAILS_FORM_FIELDS.TOTAL_DAILY_MAX_TRANSACTIONS_VALUE], type: VALUE_TYPE.AMOUNT, shorterNumberFormat: false, currency: '$' }),
    showValueInTooltip: Number(formik.values[PROVIDER_DETAILS_FORM_FIELDS.TOTAL_DAILY_MAX_TRANSACTIONS_VALUE]) > 999,
    orientation: 'horizontal',
  },
  {
    key: PROVIDER_DETAILS_FORM_FIELDS.MC_MONTHLY_MAX_TRANSACTIONS_COUNT,
    fieldName: PROVIDER_DETAILS_FORM_FIELDS.MC_MONTHLY_MAX_TRANSACTIONS_COUNT,
    label: PROVIDER_DETAILS_FORM_FIELDS_NAMES.MC_MONTHLY_MAX_TRANSACTIONS_COUNT,
    placeholder: PROVIDER_DETAILS_FORM_FIELDS_NAMES.MC_MONTHLY_MAX_TRANSACTIONS_COUNT,
    tooltipText: PROVIDER_DETAILS_FORM_FIELDS_NAMES.TOTAL_TOOLTIP_TEXT,
    isEditable: true,
    isUnlimited: true,
    inputType: InputType.Number,
    metricValue: formik.values[PROVIDER_DETAILS_FORM_FIELDS.MC_CURRENT_TRANSACTIONS_COUNT],
    metricType: 'count',
    formattedValue: () => showFakeInputValue({ initialNumber: formik.values[PROVIDER_DETAILS_FORM_FIELDS.MC_MONTHLY_MAX_TRANSACTIONS_COUNT], type: VALUE_TYPE.COUNT, shorterNumberFormat: true }),
    formattedTooltipValue: () => showFakeInputValue({ initialNumber: formik.values[PROVIDER_DETAILS_FORM_FIELDS.MC_MONTHLY_MAX_TRANSACTIONS_COUNT], type: VALUE_TYPE.COUNT, shorterNumberFormat: false }),
    showValueInTooltip: Number(formik.values[PROVIDER_DETAILS_FORM_FIELDS.MC_MONTHLY_MAX_TRANSACTIONS_COUNT]) > 999,
    orientation: 'horizontal',
  },
  {
    key: PROVIDER_DETAILS_FORM_FIELDS.MC_MONTHLY_MAX_TRANSACTIONS_VALUE,
    fieldName: PROVIDER_DETAILS_FORM_FIELDS.MC_MONTHLY_MAX_TRANSACTIONS_VALUE,
    label: PROVIDER_DETAILS_FORM_FIELDS_NAMES.MC_MONTHLY_MAX_TRANSACTIONS_VALUE,
    placeholder: PROVIDER_DETAILS_FORM_FIELDS_NAMES.MC_MONTHLY_MAX_TRANSACTIONS_VALUE,
    tooltipText: PROVIDER_DETAILS_FORM_FIELDS_NAMES.TOTAL_TOOLTIP_TEXT,
    isEditable: true,
    isUnlimited: true,
    inputType: InputType.Number,
    metricValue: formik.values?.[PROVIDER_DETAILS_FORM_FIELDS.MC_CURRENT_TRANSACTIONS_VALUE],
    metricType: 'amount',
    metricCurrency: '$',
    formattedValue: () => showFakeInputValue({ initialNumber: formik.values[PROVIDER_DETAILS_FORM_FIELDS.MC_MONTHLY_MAX_TRANSACTIONS_VALUE], type: VALUE_TYPE.AMOUNT, shorterNumberFormat: true, currency: '$' }),
    formattedTooltipValue: () => showFakeInputValue({ initialNumber: formik.values[PROVIDER_DETAILS_FORM_FIELDS.MC_MONTHLY_MAX_TRANSACTIONS_VALUE], type: VALUE_TYPE.AMOUNT, shorterNumberFormat: false, currency: '$' }),
    showValueInTooltip: Number(formik.values[PROVIDER_DETAILS_FORM_FIELDS.MC_MONTHLY_MAX_TRANSACTIONS_VALUE]) > 999,
    orientation: 'horizontal',
  },

  {
    key: PROVIDER_DETAILS_FORM_FIELDS.VISA_MONTHLY_MAX_TRANSACTIONS_COUNT,
    fieldName: PROVIDER_DETAILS_FORM_FIELDS.VISA_MONTHLY_MAX_TRANSACTIONS_COUNT,
    label: PROVIDER_DETAILS_FORM_FIELDS_NAMES.VISA_MONTHLY_MAX_TRANSACTIONS_COUNT,
    placeholder: PROVIDER_DETAILS_FORM_FIELDS_NAMES.VISA_MONTHLY_MAX_TRANSACTIONS_COUNT,
    tooltipText: PROVIDER_DETAILS_FORM_FIELDS_NAMES.TOTAL_TOOLTIP_TEXT,
    isEditable: true,
    isUnlimited: true,
    inputType: InputType.Number,
    metricValue: formik.values[PROVIDER_DETAILS_FORM_FIELDS.VISA_CURRENT_TRANSACTIONS_COUNT],
    metricType: 'count',
    formattedValue: () => showFakeInputValue({ initialNumber: formik.values[PROVIDER_DETAILS_FORM_FIELDS.VISA_MONTHLY_MAX_TRANSACTIONS_COUNT], type: VALUE_TYPE.COUNT, shorterNumberFormat: true }),
    formattedTooltipValue: () => showFakeInputValue({ initialNumber: formik.values[PROVIDER_DETAILS_FORM_FIELDS.VISA_MONTHLY_MAX_TRANSACTIONS_COUNT], type: VALUE_TYPE.COUNT, shorterNumberFormat: false }),
    showValueInTooltip: Number(formik.values[PROVIDER_DETAILS_FORM_FIELDS.VISA_MONTHLY_MAX_TRANSACTIONS_COUNT]) > 999,
    orientation: 'horizontal',
  },
  {
    key: PROVIDER_DETAILS_FORM_FIELDS.VISA_MONTHLY_MAX_TRANSACTIONS_VALUE,
    fieldName: PROVIDER_DETAILS_FORM_FIELDS.VISA_MONTHLY_MAX_TRANSACTIONS_VALUE,
    label: PROVIDER_DETAILS_FORM_FIELDS_NAMES.VISA_MONTHLY_MAX_TRANSACTIONS_VALUE,
    placeholder: PROVIDER_DETAILS_FORM_FIELDS_NAMES.VISA_MONTHLY_MAX_TRANSACTIONS_VALUE,
    tooltipText: PROVIDER_DETAILS_FORM_FIELDS_NAMES.TOTAL_TOOLTIP_TEXT,
    isEditable: true,
    isUnlimited: true,
    inputType: InputType.Number,
    metricValue: formik.values?.[PROVIDER_DETAILS_FORM_FIELDS.VISA_CURRENT_TRANSACTIONS_VALUE],
    metricType: 'amount',
    metricCurrency: '$',
    formattedValue: () => showFakeInputValue({ initialNumber: formik.values[PROVIDER_DETAILS_FORM_FIELDS.VISA_MONTHLY_MAX_TRANSACTIONS_VALUE], type: VALUE_TYPE.AMOUNT, shorterNumberFormat: true, currency: '$' }),
    formattedTooltipValue: () => showFakeInputValue({ initialNumber: formik.values[PROVIDER_DETAILS_FORM_FIELDS.VISA_MONTHLY_MAX_TRANSACTIONS_VALUE], type: VALUE_TYPE.AMOUNT, shorterNumberFormat: false, currency: '$' }),
    showValueInTooltip: Number(formik.values[PROVIDER_DETAILS_FORM_FIELDS.VISA_MONTHLY_MAX_TRANSACTIONS_VALUE]) > 999,
    orientation: 'horizontal',
  },
];
